<template>
    <Row>
        <navbar></navbar>
        <div class="mogos_main">
            <div class="mogos_main_page">
                <div class="detail_slide_1" ref="mybox">
                    <div style="position:absolute;top:40%;left: 0;right:0;bottom:0;">
                        <i-col span="24">
                            <img src="../../assets/store/mogos_logo.png" class="mogos-logo">
                            <p class="details_banner_text">
                                任你飞全球，无限流量享自由
                            </p>
                        </i-col>
                    </div>
                </div>
                <div class="layout-content" style="z-index: 1;">
                    <div class="Product-content mogos">
                        <div class="Product-content" style="background: #FFFFFF;padding:10% 0 10% 0;">
                            <Row style="padding:0 3% 0 3%">
                                <Col class="Product-left" :md="13" style="text-align: center;">
                                <img src="../../assets/store/mogos_card.png" class="mogos-logo">
                                </Col>
                                <Col class="Product-right" :md="11" style="text-align: left;">
                                <p class="Product-name">
                                    MOGO S
                                </p>
                                <p class="Product-price">
                                    ${{goods_info.goods_price}}
                                </p>
                                <p class="Product-details">
                                    MOGO S是一张连接全球通讯的上网卡，覆盖超过200个国家。以优秀的移动数据资源为全球旅客提供稳定快速的网络，保证旅途中每一个联系的便捷性。零漫游的技术使用户随时随地都连接到当地的3G／4G网络，更低的当地资费为用户节省了大量的通讯费用。从此，跨境通讯将和本地无异。
                                </p>
                                <ul>
                                    <li class="Product-details-li">使用当地网络，为您节省95%的通讯费</li>
                                    <li class="Product-details-li">插卡即联网，操作简单便捷</li>
                                    <li class="Product-details-li">线上续购套餐，无需登记等待</li>
                                </ul>
                                <buy :id="parseInt($route.params.id)"
                                     :maxCount="parseInt(goods_info.store_count)"></buy>

                                </Col>
                            </Row>
                        </div>

                        <div class="Product-content speedy">
                            <div style="background:rgba(31,45,61,0.3);padding:20px 0 20px 0;">
                                <Row>
                                    <p class="Product-tips">
                                        一卡在手，便捷随行
                                    </p>
                                </Row>
                                <Row style="" :gutter="30" class="details-card">
                                    <Col :xs="12" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/mogos_icon1.png">
                                            <span style="display: block;">零漫游 :</span>
                                            <span style="display: block;">在全球都是连接<br>当地的网络</span>
                                        </div>
                                    </Card>
                                    </Col>
                                    <Col :xs="12" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/mogos_icon2.png">
                                            <span style="display: block;">零月租 :</span>
                                            <span style="display: block;">随时需要<br>随时启用</span>
                                        </div>
                                    </Card>
                                    </Col>
                                    <Col :xs="12" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/mogos_icon3.png">
                                            <span style="display: block;">低资费 :</span>
                                            <span style="display: block;">用当地费率<br>计费便宜不超支</span>
                                        </div>
                                    </Card>
                                    </Col>

                                    <i-col :xs="12" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/mogos_icon4.png">
                                                <span style="display: block;">国家多 :</span>
                                                <span style="display: block;">一卡覆盖全球<br>200+国家</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                    <i-col :xs="12" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/mogos_icon5.png">
                                                <span style="display: block;"> 省时间 :</span>
                                                <span style="display: block;">在iAPP就搞定<br>所有上网功能</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                    <i-col :xs="12" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/mogos_icon6.png">
                                                <span style="display: block;"> 服务好:</span>
                                                <span style="display: block;">24小时的<br>客户服务支持</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                </Row>
                            </div>
                        </div>

                        <div class="details_iapp_banner">
                            <i-col span="24">
                                <div class="layout-conten" style="height:800px;background:#FFF;">
                                    <div class="swiper-container">
                                        <i-col :xs="24" :sm="{span:12,offset:12}" :md="{span:12,offset:11}"
                                               :lg="{span:12,offset:11}" style="position: absolute;top: 0;">
                                            <p class="details_iapp_text details_iapp_text1">
                                                3步快速联网
                                            </p>
                                            <p class="details_iapp_text details_iapp_text2">
                                                SIM卡 + 流量套餐
                                            </p>
                                        </i-col>
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide slider1" style="position: relative;">
                                            </div>
                                            <div class="swiper-slide slider2">
                                            </div>
                                            <div class="swiper-slide slider3">
                                            </div>
                                        </div>
                                        <!-- Add Pagination -->
                                        <div class="swiper-pagination">
                                        </div>
                                        <i-col span="12" offset="12">
                                            <p class="details_iapp_text"
                                               style="font-size: 40px;color: #1F2D3D;line-height: 78px;">
                                                3步快速联网
                                            </p>
                                            <p class="details_iapp_text"
                                               style="font-size: 22px;color: #5E6D82;line-height: 40px;">
                                                SIM卡 + 流量套餐
                                            </p>
                                        </i-col>
                                    </div>
                                </div>
                            </i-col>
                        </div>

                        <div class="Product-content">
                            <Row style="padding:0 3% 0 3%">
                                <i-col class="Product-right" :md="24" style="text-align: center">
                                    <p class="Product-name">
                                        覆盖全球200+国家
                                    </p>
                                </i-col>
                                <Row class="detail_country">
                                    <i-col class="detail-button" :xs="24" :sm="24" :md="6" :lg="6">
                                        <i-col span="24" style="margin-bottom: 20px;">
                                            <Button class="details_global" :key="index" v-for="(item,index) in tabs"
                                                    :class="{details_global_active:index == num}" @click="tab(index)">{{item}}
                                            </Button>
                                        </i-col>
                                        <div class="tabCon"
                                             style="width:80%;margin:20px auto;font-size: 16px;color: #5E6D82;line-height: 24px;">
                                            <div v-for='(itemCon,index) in tabContents' v-show=" index == num">{{itemCon}}</div>
                                        </div>
                                    </i-col>
                                    <i-col class="detail-content" :xs="24" :sm="24" :md="18" :lg="18">
                                        <img src="../../assets/store/map.png" style="margin-top:6%;width:80%;">
                                    </i-col>
                                </Row>
                            </Row>
                        </div>

                        <div class="Product-content detials_purchase" style="padding:10% 3% 10% 10%">
                            <Row>
                                <i-col class="Product-right" :md="9" style="text-align: left">
                                    <p class="Product-name" style="color:#fff;">
                                        畅想飞速上网体验
                                    </p>
                                    <div class="Product-details" style="color:#fff;margin-top:30px;">
                                        <p>此处应有文案此处应有文案此处应有文案</p>
                                        <p>此处应有文案</p>
                                    </div>
                                    <button class="Product-btn" style="color:#fff;background-color:#0084ff;"
                                            @click="buyNow">
                                        马上购买
                                    </button>
                                </i-col>
                            </Row>
                        </div>
                        <div class="detail-basis max_width">
                            <guess></guess>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Row>
</template>
<script>
    import Swiper from '../../../static/js/swiper-3.4.2.min'
    import navbar from '../Common/Navbar.vue'
    import buy from '../Common/Buy.vue'
    import guess from '../Profiler/Common/Guess.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                value1: 0,
                minus_text: 1,
                scroll: '',
                active: false,
                tabs: ['亚洲', '南美洲', '非洲', '大洋洲', '北美洲', '欧洲'],
                tabContents: ['爱沙尼亚、拉脱维亚、立陶宛', '立陶宛、白俄罗斯、俄罗斯、乌克兰、摩尔多瓦', '白俄罗斯、俄罗斯、乌克兰、摩尔多瓦', '爱沙尼亚、拉脱维亚、立陶宛、白俄罗斯、俄罗斯', '爱沙尼亚、拉脱维亚、摩尔多瓦', '爱沙尼亚、拉脱维亚、立陶宛、白俄罗斯、俄罗斯、乌克兰、摩尔多瓦'],
                num: 1,
                goods_info: {}
            }
        },
        components: {
            navbar, buy, guess
        },
        created () {
            let module = 'index.php/index/goods/goodsinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$config.defaults.l
            data.goods_id = this.$route.params.id
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.goods_info = resp.data.data.goods_info
                }
            }.bind(this))
        },
        mounted () {
            window.addEventListener('scroll', this.init)
            var swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                direction: 'vertical',
                loop: false,
                speed: 1000,
                autoplay: false,
                mousewheelReleaseOnEdges: true,
                mousewheelControl: true,
                effect: 'fade',
                fade: {
                    crossFade: true,
                },
                onTouchEnd: function () {
                    swiper.startAutoplay()
                }
            })
            $('.swiper-pagination span:nth-of-type(1)').html('<p><span>1</span>在APP购买流量套餐</p>')
            $('.swiper-pagination span:nth-of-type(2)').html('<p><span>2</span>到达目的地，插入卡片</p>')
            $('.swiper-pagination span:nth-of-type(3)').html('<p><span>3</span>设置当地APN</p>')
        },
        methods: {
            addShopCart (count) {
                this.addToCart(count)
            },
            tab (index) {
                this.num = index
            },
            buyNow () {
                this.$router.push({
                    name: 'Settlement',
                    query: {
                        goods_id: this.$route.params.id,
                        number: 1
                    }
                })
            },
        }

    }
</script>
<style lang="scss">
    @import '../../assets/css/swiper-3.4.2.min.css';

    .mogos_main {
        perspective: 1px;
        padding: 0;
        height: 100%;
        overflow: auto;

    }

    .detail_slide_1 {
        height: 100vh;
        background: url("../../assets/store/mogo s_pic1.jpg") no-repeat center;
        background-size: cover;
        position: relative;
        overflow: hidden;
        transform: translate3D(0%, -500px, -1px) scale(2);
    }

    .speedy {
        background: url('../../assets/store/Detail_mogos_pic2.jpg') no-repeat center;
        background-size: cover;
    }

    .details_banner_text {
        /*font-family: PingFangSC-Semibold;*/
        font-size: 22px;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 40px;
        margin-top: 30px;
    }

    .mogos {
        position: relative;
    }

    .Product-name {
        font-size: 56px;
        color: #1F2D3D;
        line-height: 56px;
    }

    .Product-price {
        font-size: 40px;
        color: #0084ff;
        line-height: 26px;
        margin: 3% 0 3% 0;
    }

    .Product-details {
        /*font-family: Roboto-Regular;*/
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 22px;
        padding: 0 20% 2% 0;
    }

    .Product-details-li {
        font-size: 16px;
        color: #5E6D82;
    }

    .Product-btn {
        border: 1px solid #0084FF;
        border-radius: 5px;
        height: 50px;
        width: 200px;
        font-size: 20px;
        color: #0084FF;
        background: transparent;
        margin: 5% 6% 0% 0%;
    }

    .Product-btn:hover {
        background: #0084FF;
        color: white;
        /*font-weight: 600;*/
    }

    .Product-more {
        font-size: 16px;
    }

    .details_card_text {
        margin: 15px 0;
    }

    .details_card_text div {
        /*font-family: PingFangSC-Regular;*/
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 0 !important;
        padding: 15px 0;
    }

    .detail_country {
        margin-bottom: 5%;
    }

    .detail-button {
        margin-top: 12%;
    }

    /*backtop*/
    .swiper-container {
        width: 100%;
        height: 100%;
    }

    .swiper-slide {
        color: white;
        text-align: center;
        font-size: 18px;
        background: #fff;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }

    /*slider-main-page*/
    .details_iapp_banner {
        height: 100vh;
        padding: 8% 0;
    }

    .details_iapp_text {
        /*font-family: PingFangSC-Regular;*/
        letter-spacing: 0;
    }

    .details_iapp_text1 {
        font-size: 50px;
        color: #1F2D3D;
        line-height: 78px;
    }

    .details_iapp_text2 {
        font-size: 22px;
        color: #5E6D82;
        line-height: 40px;
    }

    .details_iapp_banner .slider1 {
        background: url('../../assets/store/mogos_phone1.png');
        background-repeat: no-repeat;
        background-position: 20%;
        background-size: contain;
    }

    .details_iapp_banner .slider2 {
        background: url('../../assets/store/mogos_phone2.png');
        background-repeat: no-repeat;
        background-position: 20%;
        background-size: contain;
    }

    .details_iapp_banner .slider3 {
        background: url('../../assets/store/mogos_phone3.png');
        background-repeat: no-repeat;
        background-position: 20%;
        background-size: contain;
    }

    .details_iapp_banner .swiper-pagination-bullet {
        background: white;
    }

    .details_iapp_banner .swiper-container-vertical > .swiper-pagination-bullets {
        right: 35%;
        top: 35%;
    }

    .details_iapp_banner .swiper-pagination-bullet {
        width: 16px;
        height: 16px;
        margin-top: 2% !important;
        /*background: url("../../assets/store/.png") center;*/
        background-size: 100% 100%;
    }

    .details_iapp_banner .swiper-main {
        width: 35%;
        text-align: left;
        position: absolute;
        left: 50%;
    }

    .details_iapp_banner .swiper-main-title {
        margin: -15% 0 5% 0;
        font-size: 3em;
    }

    .details_iapp_banner .swiper-main-page {
        font-size: 17px;
        line-height: 26px;
    }

    .swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 20px 0;
    }

    .swiper-pagination span p {
        /*font-family: PingFangSC-Regular;*/
        width: 300px;
        text-align: left;
        line-height: 24px;
    }

    .swiper-pagination span p span {
        margin: 0 40px 0 5px;
        color: #fff;
        font-size: 14px;
    }

    .details_iapp_banner .swiper-pagination-bullet-active {
        background: url("../../assets/store/selected_right.png") center;
        background-size: 100% 100%;
        border-radius: 0 !important;
        width: 32px;
        height: 100%;
        color: #0084ff !important;
        font-size: 18px !important;
    }

    .detail_country {
        background: url("../../assets/store/map.png") center;
        background-repeat: no-repeat;

    }

    .detail-button {
        padding: 200px 0;
    }

    .details_global {
        color: #0084ff;
        border: 1px solid #0084ff;
        width: 120px;
        margin: 2%;
        font-size: 14px;
        background-color: #fff;
    }

    .details_global_active {
        color: #fff;
        background-color: #0084ff;
    }

    .details_global_active:hover {
        color: #fff;
        background-color: #0084ff;
    }

    .detials_purchase {
        background: url("../../assets/store/mogos_pic3.jpg") center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    /*滚动条*/
    ::-webkit-scrollbar {
        width: 0px;
    }

    .Product-tips {
        /*font-family: PingFangSC-Regular;*/
        font-size: 50px;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 78px;
        margin: 50px 0 20px 0;
    }

    .details-card {
        width: 50%;
        margin: 0 auto !important;
    }

    @media screen and (max-width: 992px) {
        .Product-left, .Product-right {
            text-align: center !important;
        }
    }

    @media screen and (max-width: 768px) {
        .mogos-logo {
            width: 80%;
        }

        .details_banner_text {
            font-size: 16px;
        }

        .Product-tips {
            font-size: 35px;
        }

        .details-card {
            width: 70%;
        }

        .Product-search {
            width: 100% !important;
            font-size: 24px;
        }

        .Product-btn {
            margin: 5% 0 0 0;
        }

        .detail_country {
            background: none;
        }

        .detail-button {
            padding: 100px 0;
        }

        .details_iapp_text1 {
            font-size: 40px;
            color: #1F2D3D;
            line-height: 78px;
        }

        .details_iapp_text2 {
            font-size: 20px;
            color: #5E6D82;
            line-height: 40px;
        }
    }

    @media screen and (max-width: 500px) {
        .details-card {
            width: 100%;
        }

        .Product-tips {
            font-size: 30px;
        }

        .details_iapp_banner .swiper-container-vertical > .swiper-pagination-bullets {
            display: none !important;
        }

        .Product-name {
            font-size: 30px;
        }

        .details_iapp_banner .swiper-slide {
            background-position: center !important;
            background-size: 65%;
        }
    }

    @media screen and (max-width: 1000px) {
        .Product-details {
            padding: 0px 0% 2% 0px;
        }
    }

    @media screen and (min-width: 500px) {
        .detail_slide_1 {
            height: 100vh;
            background: url("../../assets/store/mogo s_pic1.jpg") no-repeat center;
            background-size: cover;
            position: relative;
            overflow: hidden;
            transform: translate3D(0%, -500px, -1px) scale(2);
        }
        .mogos_main_page {
            height: 2000px;
            transform-style: preserve-3d;
        }
    }

    ::-webkit-scrollbar {
        width: 0px;
    }
</style>



// WEBPACK FOOTER //
// ProductDetails.vue?778738b9